<template>
    <div>
        <v-data-table class="no-footer-table list-view" :headers="headers" :items="formattedFlights" :items-per-page="-1">
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: ['flights'],

    computed : {
        instructorNames() {
            return this.$store.getters.activeInstructors.map(instructor => instructor.name)
        },


        formattedFlights() {
            return this.flights.map(flight => {
                let transformedFlight = { ...flight }

                flight.assigned_jumps.forEach(assignedJump => {
                    transformedFlight[assignedJump.instructorName] = `${assignedJump.code} - ${assignedJump.fullName}`
                });
                // Remove the 'assigned_jumps' property from the transformed flight
                delete transformedFlight.assigned_jumps
                return transformedFlight
            });
        },
        headers() {

            let headers = [{
                text : 'LOAD',
                value : 'number'
            }]

            this.instructorNames.forEach( i => {
                headers.push({
                    text : i.toUpperCase(),
                    value: i
                })
            })

            return headers
        }

    }

}
</script>
